export default __webpack_public_path__ + "c8b6c05392a9f30b72ea7b17190f87a8.png";